import { Content } from "modules/reporting/components/layout";
import { BranchSalesPanel, CampaignConversionPanel, ConsumerPanel, DemographicPanel, FilterPanelV3, MiscellaneousPanel } from "modules/reporting/components/panel";
import React from "react";

export default function ConsumerPage({
    filter,
    tagUrl,
    currentFilter,
    pageMode,
    translate
}) {
    const pageType = "consumer";
    return (
        <>
            <FilterPanelV3
                filter={filter}
                currentFilter={currentFilter}
                pageMode={pageMode}
                translate={translate}
            />

            <Content>
                {/* trending card --- START */}
                <ConsumerPanel  
                    currentFilter={currentFilter}
                    urlTotalScan={tagUrl.tagQRUrl + "get-total-scan-qr"}
                    urlTotalSuspended={tagUrl.tagQRUrl + "get-total-suspended-qr"}
                    urlTotalDistributionPerformance={tagUrl.tagQRUrl + "get-distribution-performance"}
                    urlGetConsumerList={tagUrl.tagConsumerUrl + "get-consumer-details"}
                    urlScanAgainstSuspended = {tagUrl.tagQRUrl + "scan-vs-suspended"}

                    pageType={pageType}
                    translate={translate}
                />
                {/* trending card --- END */}

                {/* campaign conversion  --- START */}
                <CampaignConversionPanel 
                    currentFilter={currentFilter} 
                    url={tagUrl.tagQRUrl + "get-campaigns-conversion"} 
                    // url={"http://localhost:9080/campaignConversionDrilldown"}
                    
                    pageType={pageType}
                    translate={translate}
                />
                {/* campaign conversion  --- END */}

                {/* demographic card row --- START*/}
                <DemographicPanel 
                    currentFilter={currentFilter} 
                    urlAge={tagUrl.tagQRUrl + "get-total-age"} 
                    urlGender={tagUrl.tagQRUrl + "get-total-gender" } 
                    urlGenderAge={tagUrl.tagQRUrl + "get-total-gender-age"}
                    urlCountry={tagUrl.tagQRUrl + "get-country"}
                    urlCity={tagUrl.tagQRUrl + "get-city"}

                    pageType={pageType}
                    translate={translate}
                />
                {/* demographic card row --- END */}

                {/* branch sales detail row --- START*/}
                {
                    !currentFilter.branchUuid ? 
                    (
                        <BranchSalesPanel 
                            url={tagUrl.tagQRUrl + "get-branch"}
                            currentFilter={currentFilter}
        
                            pageType={pageType}
                            translate={translate}
                        /> 
                    ): null
                }
                {/* branch sales detail row --- END*/}  

                {/* miscellaneous card row --- START */}
                <MiscellaneousPanel 
                    currentFilter={currentFilter}
                    urlPlatform={tagUrl.tagQRUrl + "get-total-platform"}
                    urlDevice={tagUrl.tagQRUrl + "get-total-device"}
                    urlBrowser={tagUrl.tagQRUrl + "get-total-browser"}
                    urlLanguage={tagUrl.tagQRUrl + "get-total-language"}

                    translate={translate}
                />
                {/* miscellaneous card row --- END */}
            </Content>
        </>
    )
}